import { defineStore } from 'pinia';
import { useUtilsStore, useVerifyStore } from "@/store";

export const useAuthStore = defineStore({
	id: 'auth',
	state: () => ({
		CUID: JSON.parse(localStorage.getItem('CUID')) || null,
		userInfoMyVTC: JSON.parse(localStorage.getItem('userInfoMyVTC')) || null,
		username: "",
		password: "",
		secureCode: "",
		secureDataInfo: "",
		secureTypeID: 0,
		serviceId: process.env.VUE_APP_DEFAULT_SERVICE_ID,
		serviceName: "",
		redirectUrl: process.env.VUE_APP_DEFAULT_REDIRECT_URL,
		autoRedirect: true,
		requestId: "",
		signNextStep: "",
		relateAccount: "",
		action: -1
	}),
	getters: {
		isAuthenticate: (state) => state.userInfoMyVTC != null && state.userInfoMyVTC.AccessToken != null,
	},
	actions: {
		async login() {
			let raw = {
				"RequestID": "",
				"DeviceDetail": useUtilsStore().getDeviceDetail(),
				"ClientIP": "",
				"ServiceID": this.serviceId,
				"AccountName": this.username || "",
				"Password": this.password || "",
				"TrustDevice": true,
				"Location": "",
				"SecureCode": this.secureCode || "",
				"SecureTypeID": this.secureTypeID || 0,
				"DeviceID": "",
				"IsVerifyMobile": this.action>0 ? true : false,
			}
			const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/Account_Authenticate`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(raw),
			}).then((res) => {
				return res.json();
			});
			if (response.Status) {
				this.CUID = response.Data.CUID;
				this.userInfoMyVTC = response.Data.AccountAuthenInfo;
				localStorage.setItem('CUID', JSON.stringify(this.CUID));
				localStorage.setItem('userInfoMyVTC', JSON.stringify(this.userInfoMyVTC));
			}
			return response;
		},
		async verifyAccount(type) {
			let raw = {
				"RequestID": "",
				"DeviceDetail": useUtilsStore().getDeviceDetail(),
				"ClientIP": "",
				"ServiceID": this.serviceId,
				"AccountName": this.username || "",
				"Password": this.password || "",
				"TrustDevice": true,
				"Location": "",
				"SecureCode": this.secureCode || "",
				"SecureTypeID": this.secureTypeID || 0,
				"DeviceID": "",
				"RelateAccount": this.relateAccount,
				"Type": type
			}
			const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/AccountVerify`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(raw),
			}).then((res) => {
				return res.json();
			});
			if (response.Status) {
				this.CUID = response.Data.CUID;
				this.userInfoMyVTC = response.Data.AccountAuthenInfo;
				localStorage.setItem('CUID', JSON.stringify(this.CUID));
				localStorage.setItem('userInfoMyVTC', JSON.stringify(this.userInfoMyVTC));
			}
			return response;
		},
		async loginByOTP(step) {
			let raw = {
				"RequestID": this.requestId,
				"DeviceDetail": useUtilsStore().getDeviceDetail(),
				"ClientIP": "",
				"ServiceID": this.serviceId,
				"AccountName": this.username || "",
				"TrustDevice": true,
				"Location": "",
				"SecureCode": this.secureCode || "",
				"SecureTypeID": this.secureTypeID || 0,
				"Step": step,
				"Sign": this.signNextStep,
				"DeviceID": ""
			}
			const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/AuthenticateByOTP`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(raw),
			}).then((res) => {
				return res.json();
			});
			if (response.Status) {
				this.CUID = response.Data.CUID;
				this.userInfoMyVTC = response.Data.AccountAuthenInfo;
				localStorage.setItem('CUID', JSON.stringify(this.CUID));
				localStorage.setItem('userInfoMyVTC', JSON.stringify(this.userInfoMyVTC));
			}
			return response;
		},
		async loginByCuid() {
			let raw = {
				"RequestID": "",
				"DeviceDetail": useUtilsStore().getDeviceDetail(),
				"ClientIP": "",
				"ServiceID": this.serviceId,
				"CUID": this.CUID,
				"DeviceID": ""
			}
			const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/AuthenticateByCUID`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(raw),
			}).then((res) => {
				return res.json();
			});
			if (response.Status) {
				this.userInfoMyVTC = response.Data.AccountAuthenInfo;
				localStorage.setItem('userInfoMyVTC', JSON.stringify(this.userInfoMyVTC));
			}
			return response;
		},
		async checkAccount() {
			let serviceid = this.serviceId;
			let raw = {
				"RequestID": "",
				"DeviceDetail": useUtilsStore().getDeviceDetail(),
				"ClientIP": "",
				"AccountName": this.username
			}
			const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/CheckAccountExist`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(raw),
			}).then((res) => {
				return res.json();
			});
			return response;
		},
		async getAccount(code) {
			let raw = {
				"RequestID": "",
				"DeviceDetail": useUtilsStore().getDeviceDetail(),
				"ClientIP": "",
				"Code": code,
				"ServiceID": this.serviceId,
				"ServiceKey": "",
				"RedirectURL": ""
			}
			const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/GetUserInfo`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(raw),
			}).then((res) => {
				return res.json();
			});
			return response;
		},
		async CreateShareInfo(createShareInfoRequest) {
			try {
				let requestData = {
					RequestID: "",
					DeviceDetail: useUtilsStore().getDeviceDetail(),
					ClientIP: await useUtilsStore().getIPAddress(),
					Code: createShareInfoRequest.Code
				};

				const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/CreateShareInfo`,
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify(requestData),
					}
				).then((res) => {
					return res.json();
				});

				return response;
			} catch (ex) {
				console.log("ex: " + ex);
			}
		},
		async checkAccessToken() {
			try {
				let requestData = {
					RequestID: '',
					DeviceDetail: this.userInfoMyVTC.DeviceDetail,
					ClientIP: this.userInfoMyVTC.ClientIP,
					AccessToken: this.userInfoMyVTC.AccessToken,
					AccountName: this.userInfoMyVTC.AccountName,
					AccountID: this.userInfoMyVTC.AccountID,
				};

				const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/CheckAccessToken`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(requestData),
				}).then((res) => {
					return res.json();
				});

				return response;
			} catch (ex) {
				console.log("ex: " + ex);
			}
		},
		async clearData() {
			this.CUID = null;
			localStorage.removeItem('CUID');
			this.userInfoMyVTC.AccessToken = null;
			this.userInfoMyVTC.DeviceDetail = null;
			this.userInfoMyVTC.ClientIP = null;
			this.userInfoMyVTC.AccountID = null;
			localStorage.setItem('userInfoMyVTC', JSON.stringify(this.userInfoMyVTC));
		},
		async logout() {
			// Thực hiện logic đăng xuất ở đây, gọi API đăng xuất, xóa accesstoken
			try {
				let requestData = {
					RequestID: '',
					DeviceDetail: this.userInfoMyVTC.DeviceDetail,
					ClientIP: this.userInfoMyVTC.ClientIP,
					AccessToken: this.userInfoMyVTC.AccessToken,
					AccountName: this.userInfoMyVTC.AccountName
				};

				const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/LogOut`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(requestData),
				}).then((res) => {
					return res.json();
				});

				if (response.ResponseCode > 0) {
					await this.clearData();
				}

				return response;
			} catch (ex) {
				console.log("ex: " + ex);
			}
		},
		loginSuccess(router, code) {
			if (this.relateAccount && this.action >= 0) {
				router.push({
					name: 'shareinfo',
					state: { code: code }
				});
				return;
			}
			if (this.autoRedirect === 'false') {
				router.push({
					name: 'redirect',
					state: { code: code }
				});
				return;
			}
			useUtilsStore().redirectWithParams(`${this.redirectUrl}`, { code: code })
		}
	}
});